const heroBanner = document.querySelector('.hero-banner-slider-with-animation--wrapper');
const heroBackground = document.querySelector('.hero-banner-slider-background');
const slider = heroBanner ? heroBanner.querySelector('carousel-component') : null;
const animatedImage = document.querySelector('.static-initial-background img');

if (heroBanner && !heroBanner.classList.contains('no-animation') && animatedImage) {
  function animateHeroBanner(){
    if(!heroBanner) return;
    if(!heroBanner.classList.contains('animated')){
      heroBanner.classList.add('animated');
    }
  }

  history.scrollRestoration = 'manual';

  window.addEventListener('touchstart', animateHeroBanner, { once: true });
  window.addEventListener('mousewheel', animateHeroBanner, { once: true });
  window.addEventListener('click', animateHeroBanner, { once: true });

  window.addEventListener('DOMContentLoaded',()=>{
    setTimeout(animateHeroBanner,2000);
  });

  if (heroBackground) {
    heroBackground.addEventListener('transitionend', (e) => {
      heroBanner.classList.add('auto');
      if (animatedImage) animatedImage.classList.add('hidden');
      if (slider && slider.carousel) slider.carousel.options = { drag: true };
    });
  }
}
